import { makeDefaultTypographyStyled } from '../typography-styled';

export const StyledHeading6 = makeDefaultTypographyStyled(
  'Heading6',
  'h6',
  1,
  1.2,
);
